export default __webpack_public_path__ + "static/media/restream.da109720.svg";